import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import AppContainer from 'AppContainer';
import 'assets/css/index.css';
import 'leaflet/dist/leaflet.css';
import "leaflet-draw/dist/leaflet.draw.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppContainer />
  </BrowserRouter>
);
